import { usePerson } from '../contexts/PersonContext'
import { HomeParentPage } from './HomeParentPage'
import { HomeKidPage } from './HomeKidPage'

/**
 * Role-aware home. Both halves are Wave-2 owned and are wired here by the LEAD, because
 * this file is Foundation-owned and builders were forbidden from editing it:
 *   parent -> HomeParentPage (COTC_FriendsApprovals: activity, families, safety alerts)
 *   kid    -> HomeKidPage    (COTC_Rooms: play-now, open rooms, waiting-on-a-grown-up)
 *
 * CotRole is only 'parent' | 'kid', and a SOLO account holder derives to 'parent'
 * (deriveRole keys on "is this the account holder"), so the fallback below is exactly the
 * kid role — a solo adult can never land on the children's home.
 * WorkGroupID: kc-feat-circle-of-trust-site-20260821-013216
 */
export function HomePage() {
  const { role } = usePerson()
  return role === 'parent' ? <HomeParentPage /> : <HomeKidPage />
}
